// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gdrive-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.gdrive-modal-content {
  background: white;
  border-radius: 12px;
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.gdrive-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 24px;
  border-bottom: 1px solid #eee;
}

.gdrive-modal-header h2 {
  margin: 0;
  font-size: 1.25rem;
  color: #333;
  display: flex;
  align-items: center;
}

.gdrive-modal-close {
  background: none;
  border: none;
  font-size: 1.25rem;
  color: #666;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  transition: background-color 0.2s;
}

.gdrive-modal-close:hover {
  background-color: #f0f0f0;
}

.gdrive-modal-body {
  padding: 24px;
}

.gdrive-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #5616ea;
}

.gdrive-loading p {
  margin-top: 16px;
  color: #666;
}

.gdrive-no-connections {
  text-align: center;
  padding: 20px;
  padding-top: 0;
  padding-bottom: 0;
}

.gdrive-no-connections p {
  color: #666;
  margin-bottom: 12px;
}

.gdrive-hint {
  font-size: 0.9rem;
  color: #888 !important;
  margin-bottom: 20px !important;
}

.gdrive-connect-button {
  background-color: #5616ea;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  display: inline-flex;
  align-items: center;
}

.gdrive-connect-button:hover {
  background-color: #4a14d6;
}

.gdrive-account-selector {
  margin-bottom: 8px;
}

.gdrive-add-account-link {
  display: inline-block;
  margin-top: 8px;
  font-size: 0.85rem;
  color: #5616ea;
  cursor: pointer;
  text-decoration: underline;
}

.gdrive-add-account-link:hover {
  color: #4a14d6;
}

.gdrive-selected-account {
  background-color: #f3eaff;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  border-left: 4px solid #5616ea;
}

.gdrive-selected-account p {
  margin: 0;
  color: #333;
}

.gdrive-picker-section {
  text-align: center;
  padding: 0;
}

.gdrive-file-tag-parent {
  display: flex;
  justify-content: center;
  gap: 5px;
  margin-bottom: 20px;
}

.gdrive-file-tag {
  display: inline-block;
  padding: 5px 7px 5px 7px;
  border-radius: 10px;
  background-color: #e2e2e2;
  color: #3a3a3a;
  font-size: 14px;
}

.gdrive-instructions {
  color: #666;
  margin-bottom: 20px;
  line-height: 1.5;
}

.gdrive-open-picker-button {
  background-color: #4285f4;
  color: white;
  border: none;
  padding: 14px 28px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  display: inline-flex;
  align-items: center;
}

.gdrive-open-picker-button:hover:not(:disabled) {
  background-color: #3367d6;
}

.gdrive-open-picker-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.gdrive-supported-formats {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.gdrive-supported-formats p {
  margin: 0 0 10px 0;
  color: #333;
}

.gdrive-supported-formats ul {
  margin: 0;
  padding-left: 20px;
  color: #666;
}

.gdrive-supported-formats li {
  margin-bottom: 4px;
  font-size: 0.9rem;
}

@media (max-width: 600px) {
  .gdrive-modal-content {
    width: 95%;
    margin: 20px;
  }

  .gdrive-modal-header {
    padding: 16px 20px;
  }

  .gdrive-modal-body {
    padding: 20px;
  }

  .gdrive-open-picker-button {
    width: 100%;
    justify-content: center;
  }
}

.gdrive-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}
`, "",{"version":3,"sources":["webpack://./src/components/GoogleDrivePickerModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B","sourcesContent":[".gdrive-modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.gdrive-modal-content {\r\n  background: white;\r\n  border-radius: 12px;\r\n  max-width: 500px;\r\n  width: 90%;\r\n  max-height: 80vh;\r\n  overflow-y: auto;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.gdrive-modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 10px 24px;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.gdrive-modal-header h2 {\r\n  margin: 0;\r\n  font-size: 1.25rem;\r\n  color: #333;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.gdrive-modal-close {\r\n  background: none;\r\n  border: none;\r\n  font-size: 1.25rem;\r\n  color: #666;\r\n  cursor: pointer;\r\n  padding: 8px;\r\n  border-radius: 6px;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.gdrive-modal-close:hover {\r\n  background-color: #f0f0f0;\r\n}\r\n\r\n.gdrive-modal-body {\r\n  padding: 24px;\r\n}\r\n\r\n.gdrive-loading {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 40px 20px;\r\n  color: #5616ea;\r\n}\r\n\r\n.gdrive-loading p {\r\n  margin-top: 16px;\r\n  color: #666;\r\n}\r\n\r\n.gdrive-no-connections {\r\n  text-align: center;\r\n  padding: 20px;\r\n  padding-top: 0;\r\n  padding-bottom: 0;\r\n}\r\n\r\n.gdrive-no-connections p {\r\n  color: #666;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.gdrive-hint {\r\n  font-size: 0.9rem;\r\n  color: #888 !important;\r\n  margin-bottom: 20px !important;\r\n}\r\n\r\n.gdrive-connect-button {\r\n  background-color: #5616ea;\r\n  color: white;\r\n  border: none;\r\n  padding: 12px 24px;\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n\r\n.gdrive-connect-button:hover {\r\n  background-color: #4a14d6;\r\n}\r\n\r\n.gdrive-account-selector {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.gdrive-add-account-link {\r\n  display: inline-block;\r\n  margin-top: 8px;\r\n  font-size: 0.85rem;\r\n  color: #5616ea;\r\n  cursor: pointer;\r\n  text-decoration: underline;\r\n}\r\n\r\n.gdrive-add-account-link:hover {\r\n  color: #4a14d6;\r\n}\r\n\r\n.gdrive-selected-account {\r\n  background-color: #f3eaff;\r\n  padding: 12px 16px;\r\n  border-radius: 8px;\r\n  margin-bottom: 20px;\r\n  border-left: 4px solid #5616ea;\r\n}\r\n\r\n.gdrive-selected-account p {\r\n  margin: 0;\r\n  color: #333;\r\n}\r\n\r\n.gdrive-picker-section {\r\n  text-align: center;\r\n  padding: 0;\r\n}\r\n\r\n.gdrive-file-tag-parent {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 5px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.gdrive-file-tag {\r\n  display: inline-block;\r\n  padding: 5px 7px 5px 7px;\r\n  border-radius: 10px;\r\n  background-color: #e2e2e2;\r\n  color: #3a3a3a;\r\n  font-size: 14px;\r\n}\r\n\r\n.gdrive-instructions {\r\n  color: #666;\r\n  margin-bottom: 20px;\r\n  line-height: 1.5;\r\n}\r\n\r\n.gdrive-open-picker-button {\r\n  background-color: #4285f4;\r\n  color: white;\r\n  border: none;\r\n  padding: 14px 28px;\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n\r\n.gdrive-open-picker-button:hover:not(:disabled) {\r\n  background-color: #3367d6;\r\n}\r\n\r\n.gdrive-open-picker-button:disabled {\r\n  background-color: #ccc;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.gdrive-supported-formats {\r\n  margin-top: 24px;\r\n  padding-top: 20px;\r\n  border-top: 1px solid #eee;\r\n}\r\n\r\n.gdrive-supported-formats p {\r\n  margin: 0 0 10px 0;\r\n  color: #333;\r\n}\r\n\r\n.gdrive-supported-formats ul {\r\n  margin: 0;\r\n  padding-left: 20px;\r\n  color: #666;\r\n}\r\n\r\n.gdrive-supported-formats li {\r\n  margin-bottom: 4px;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .gdrive-modal-content {\r\n    width: 95%;\r\n    margin: 20px;\r\n  }\r\n\r\n  .gdrive-modal-header {\r\n    padding: 16px 20px;\r\n  }\r\n\r\n  .gdrive-modal-body {\r\n    padding: 20px;\r\n  }\r\n\r\n  .gdrive-open-picker-button {\r\n    width: 100%;\r\n    justify-content: center;\r\n  }\r\n}\r\n\r\n.gdrive-modal-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 10px;\r\n  margin-top: 20px;\r\n  padding-top: 20px;\r\n  border-top: 1px solid #eee;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
